import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import './UserMenu.css';

const UserMenu = () => {
  const { user, logout } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleLogout = () => {
    setIsOpen(false);
    logout();
  };

  if (!user) return null;

  const getUserInitials = () => {
    if (user.name) {
      return user.name
        .split(' ')
        .map(n => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2);
    }
    if (user.email) {
      return user.email[0].toUpperCase();
    }
    return 'U';
  };

  return (
    <div className="user-menu">
      <button className="user-menu-button" onClick={toggleMenu}>
        <div className="user-avatar">{getUserInitials()}</div>
        <span className="user-name">{user.name || user.email || 'Benutzer'}</span>
        <svg 
          className={`dropdown-icon ${isOpen ? 'open' : ''}`}
          width="12" 
          height="12" 
          viewBox="0 0 12 12"
        >
          <path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="2" fill="none" />
        </svg>
      </button>

      {isOpen && (
        <>
          <div className="user-menu-overlay" onClick={() => setIsOpen(false)} />
          <div className="user-menu-dropdown">
            <div className="user-menu-header">
              <div className="user-avatar-large">{getUserInitials()}</div>
              <div className="user-info">
                <div className="user-info-name">{user.name || 'Benutzer'}</div>
                <div className="user-info-email">{user.email || ''}</div>
              </div>
            </div>
            <div className="user-menu-divider" />
            <button className="user-menu-item" onClick={handleLogout}>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                <path d="M3 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3zm7.5 10.5l-3-3 3-3v2h4v2h-4v2z"/>
              </svg>
              Abmelden
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default UserMenu;
